const state = {
    
    blocks:[
        {
            id:1,
            name:'',
            color:'#fff',
            columns:3,
            blockcomponents: {
                columns: [
                    //left column
                    [
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Name",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte den Namen eingeben",
                                    icon:"edit",
                                    variable: 'name',
                                    setter: 'projects/PROJECT_SET_NAME',
                                    rules:"required"                                    
                            }
                        },
                        {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Nummer",
                                    size:"xs4",
                                    invertedsize:"xs7",
                                    hint:"Bitte die Nummer eingeben",
                                    icon:"edit",
                                    variable: 'number',
                                    setter: 'projects/PROJECT_SET_NUMBER',
                                                              
                            }
                        },
                        {
                            id:1,
                            name:'forminputfield',
                            attributes:{
                                    placeholder:"Beschreibung",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte eine Kurzbeschreibung eingeben",
                                    icon:"edit",
                                    variable: 'description',
                                    setter: 'projects/PROJECT_SET_DESCRIPTION',
                                                                       
                            }
                        },
                        
                                                                      
                    ],
                    [
                        {
                            id:1,
                            name:'formselect',
                            attributes: {
                                placeholder:"Kunde",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"web",
                                multiple:false,
                                icon:"search",
                                variable: 'company_ids',
                                setter: 'projects/PROJECT_SET_COMPANY',
                                items:'companies/companies',
                                withdialog:false,
                            }                                    
                        },
                        
                    ],
                    [
                        {
                            id:1,
                            name:'formdatepicker',
                            attributes: {
                                hint:"Startdatum",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"web",
                                icon:"search",
                                variable: 'started_at',
                                setter: 'projects/PROJECT_SET_STARTEDAT',                                
                            }                                    
                        },
                        {
                            id:1,
                            name:'formdatepicker',
                            attributes: {
                                hint:"Enddatum",
                                size:"xs10",
                                invertedsize:"xs1",
                                displaytitle:"name",
                                displaysubtitle:"web",
                                icon:"search",
                                variable: 'ended_at',
                                setter: 'projects/PROJECT_SET_ENDEDAT',                                
                            }                                    
                        },
                                                                      
                    ],     
                                 
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};